/**
 * Sayı alanına yazılan metni sunucunun okuyabileceği tek ayıraçlı biçime çevirir (ondalık ayıraç ".").
 *
 * Kullanıcı Türkçe alışkanlıkla binlik nokta yazabiliyor: "5.890,00". Eskiden virgül noktaya çevrildiği için
 * değer "5.890.00" oluyor, sunucu iki noktalı sayıyı okuyamıyor ve kayıt hata veriyordu (05.10.2026, Anlaşma).
 *
 * Kural: birden fazla ayıraç (nokta ya da virgül) varsa EN SONDAKİ ondalıktır, öncekiler binlik sayılıp silinir.
 *   "5.890,00" -> "5890.00", "5,890.00" -> "5890.00", "5.890.00" -> "5890.00".
 * Yazarken de aynı sonuç çıkar: alan her tuşta normalleştiği için "5.890" + "," -> "5890." olur.
 * Tek ayıraç eskisi gibi ondalıktır: "5,5" -> "5.5".
 *
 * Sınır: ondalıksız binlik ("1.234.567") son nokta ondalık sayılır -> 1234.567; "12.500" tek nokta -> 12.5
 * (bu ikincisi eskiden de böyleydi). Binlik nokta kullanılacaksa ondalık virgülle yazılmalı: "12.500,00".
 */
export const sayiGirdisiniDuzelt = (_deger: string, _negatifSerbest: boolean = false): string => {
    const s = _negatifSerbest
        ? _deger.replace(/(?!^)-|[^0-9.,-]/g, "")
        : _deger.replace(/[^0-9.,]/g, "");

    const son = Math.max(s.lastIndexOf('.'), s.lastIndexOf(','));

    if (son < 0)
        return s;

    return s.slice(0, son).replace(/[.,]/g, '') + '.' + s.slice(son + 1);
}
